<template>
    <Layout>
        <PageHeader :title="title" />

        <div class="row">
            <div class="col-xl-12">
                <div class="transactions-list" v-if="!isTransactionsLoading">
                    <div v-if="transactions">
                        <TransactionItem v-for="(transaction, index) in transactions" :key="index" :transaction="transaction" />
                    </div>

                    <div v-else class="card noresult">
                        <div class="text-center">
                            <lottie
                                class="avatar-xl"
                                colors="primary:#121331,secondary:#08a88a"
                                :options="defaultOptions"
                                :height="75"
                                :width="75"
                            />
                            <h5 class="mt-2">تراکنشی ثبت نشده است.</h5>
                        </div>
                    </div>
                </div>
                <div class="transactions-list" v-else>
                    <TransactionItemSkeleton />
                </div>

                <div v-if="transactions.length" class="d-flex justify-content-end mt-3">
                    <div class="pagination-wrap hstack gap-2">
                        <a
                            class="page-item pagination-prev disabled"
                            href="#"
                            v-if="page != 1"
                            @click="page--;  fetchPromises()"
                        >
                            قبلی
                        </a>
                        <ul class="pagination listjs-pagination mb-0">
                            <li
                                v-for="(pageNumber, index) in pages.slice(
                        page - 1,
                        page + 5
                      )"
                                :key="index"
                                @click="page = pageNumber;  fetchPromises()"
                                :class="{
                              active: pageNumber == page,
                              disabled: pageNumber == '...',
                            }"
                            >
                                <a class="page" href="#">{{ pageNumber }}</a>
                            </li>
                        </ul>
                        <a class="page-item pagination-next" href="#" @click="page++; fetchPromises()" v-if="page < pages.length">
                            بعدی
                        </a>
                    </div>
                </div>
                <!-- end card -->
            </div>
            <!-- end col -->
        </div>
        <!--end row-->
    </Layout>
</template>
<script>

import Layout from "../../../layouts/main.vue";
import appConfig from "../../../../app.config";
import PageHeader from "@/components/page-header";
import TransactionItem from "./transaction-item";
import TransactionItemSkeleton from "./transaction-item-skeleton";
import Lottie from "@/components/widgets/lottie";
import animationData from "@/components/widgets/msoeawqm.json";
import UserService from "@/services/user.service";

export default {
    page: {
        title: "تراکنش‌ها",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            title: "تراکنش‌ها",
            page: 1,
            perPage: 10,
            pages: [],
            fromDate: null,
            toDate: null,
            transactions: [],
            transactionsCount: '',
            isTransactionsLoading: true,
            defaultOptions: { animationData: animationData },
        };
    },
    components: {
        Layout,
        PageHeader,
        TransactionItem,
        TransactionItemSkeleton,
        lottie: Lottie,
    },
    computed: {
    },
    watch: {
        transactions() {
            this.setPages();
        },
    },
    created() {
        this.fetchPromises();
        this.setPages();
    },
    filters: {
        trimWords(value) {
            return value.split(" ").splice(0, 20).join(" ") + "...";
        },
    },
    methods: {
        fetchTransactions() {
            return UserService.vendorTransactions(this.perPage, this.page)
                .then((response) => {
                    const {data} = response;
                    const {transactions, total} = data;
                    this.transactions = transactions;
                    this.transactionsCount = total;
                    this.isTransactionsLoading = false;
                    // this.productsData = data.data;
                });
        },
        fetchPromises() {
            this.isTransactionsLoading = true;
            Promise.all([
                this.fetchTransactions(),
            ])
        },
        setPages() {
            this.pages = [];
            let numberOfPages = Math.ceil(this.transactionsCount / this.perPage);
            for (let index = 1; index <= numberOfPages; index++) {
                this.pages.push(index);
            }
        },
        paginate(transactions) {
            let page = this.page;
            let perPage = this.perPage;
            let from = page * perPage - perPage;
            let to = page * perPage;
            return transactions.slice(from, to);
        },
        SearchData() {
            this.resultQuery;
            // var isstatus = document.getElementById("idStatus").value;
            //   var payment = document.getElementById("idPayment").value;
        },
    },
};
</script>
